     <p>Hi {{ username }},</p>
            
                <p>I noticed you started placing an order on {{ sitename | formatSitename }} but didn’t get a chance to complete it.</p>
            
                <p>If anything was confusing — or if something held you back — feel free to reply and I’ll help however I can. Sometimes even a small clarification makes a big difference.</p>
            
                <p>No pressure — just let me know if you\'d like support finishing it up.</p>
            
                <p>Warmly,<br>
                Sarah</p>
            
                <p>—<br>
            <hr style="width:100%; border:0; height:1px; background:rgba(0, 123, 255, 0.2);">
 
            <table cellpadding="0" cellspacing="0" width="100%" style="padding-top: 20px;">
                <tr>
                    <td width="100" align="left" valign="top" style="padding-right: 10px;">
                        <img src="https://backend.skyscrapersnow.com/images/sarah.png" alt="Sarah A." width="97" height="124" style="border-radius: 8px; display: block;">
                    </td>
                    <td align="left" valign="top" style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
                         <img src="https://backend.skyscrapersnow.com/images/sarah_sign.png" alt="Sarah A Signature" style="max-width: 82px;
    max-height: 34px;
    display: block;
    margin-bottom: 5px;">
                        <p style="font-weight: 500;
    font-size: 18px;
    color: #000000;

    text-align: left;
    margin: 0;">Sarah A.</p>
                        <p style="margin: 7px 0;
    color: #767E8C;
    font-size: 13px;
    text-align: left;">Student Support Specialist</p>
                        <table cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td valign="middle" style="padding: 0px;">
                                    <img src="https://backend.skyscrapersnow.com/images/globe.png" alt="Website" width="15" height="15" style="display: block;">
                                </td>
                                <td valign="middle" style="font-size: 13px;color: #767E8C; padding: 0px 0px 0px 5px;">
                                    <a href="https://' . $site_link_clean . '" style="color: #767E8C; text-decoration: none;">{{ sitename }}</a>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
                <br>
            